import UploadProgressPopup from "./UploadProgressPopup";
import { useProgressContext } from "../../context/ProgressContext";

/**
 * Mounts the upload tray once for the WHOLE app.
 *
 * It used to live inside MainLayout, but several routes render outside that layout —
 * /file-upload, /video/:id, /Addseries, /creator-onboarding — which are exactly the
 * Add-Content screens people upload from. On those pages the tray simply did not exist,
 * so a perfectly healthy upload ran to completion with no visible progress at all. Since
 * the upload manager is a module-level singleton, the transfer worked; only the UI was
 * missing, which is indistinguishable from "nothing happened".
 *
 * Rendered inside ProgressProvider in App.js so it is present on every route. The popup
 * is position:fixed and hides itself when the queue is empty, so its placement in the
 * tree does not matter.
 */
const GlobalUploadTray = () => {
  const {
    uploadQueue,
    pauseUpload,
    resumeUpload,
    cancelUpload,
    dismissUpload,
    dismissFinishedUploads,
  } = useProgressContext();

  return (
    <UploadProgressPopup
      uploadQueue={uploadQueue}
      onPause={pauseUpload}
      onResume={resumeUpload}
      onCancel={cancelUpload}
      onDismiss={dismissUpload}
      onDismissFinished={dismissFinishedUploads}
    />
  );
};

export default GlobalUploadTray;
